"use client"

import { Bars2Icon, XMarkIcon } from "@heroicons/react/24/outline"
import { useState } from "react"
import { NotificationsNavItem } from "./NotificationsNavItem"
import { ProfileNavItem } from "./ProfileNavItem"
import debounce from "lodash/debounce"
import { VerticalNav } from "./VerticalNav"
import { FragmentType, graphql, useFragment } from "@/gql"
import type { NovaSession } from "@/types"
import { SecondarySidebar } from "../Sidebar/SecondarySidebar"
import clsx from "clsx"

const MOBILE_NAV_HEIGHT = 72

const MobileNavFragment = graphql(`
  fragment MobileNav on User {
    id
    ...NotificationsNavItem
    ...VerticalNav
    ...ProfileNavItem
  }
`)
interface Props {
  serverSession: NovaSession
  user: FragmentType<typeof MobileNavFragment> | null | undefined
}

export const MobileNav: React.FC<Props> = props => {
  const { serverSession } = props
  const [open, setOpen] = useState(false)
  const user = useFragment(MobileNavFragment, props.user)

  const toggleOpen = () => {
    debounce(() => {
      setOpen(!open)
    }, 150)()
  }

  return (
    <div className="relative">
      <div className="relative z-40 h-[72px] w-full md:hidden">
        <div className="fixed left-0 right-0 top-0 w-screen border-b border-bg-3">
          <div
            style={{ height: MOBILE_NAV_HEIGHT }}
            className="relative z-40 flex flex-row items-center justify-between bg-bg-1">
            <div onClick={toggleOpen} className="px-5">
              {open ? <XMarkIcon height="32px" width="32px" /> : <Bars2Icon height="32px" width="32px" />}
            </div>
            <div className="flex flex-row items-center gap-2 pr-5">
              {!open && (
                <NotificationsNavItem forceHideLabel user={user} size="default" serverSession={serverSession} />
              )}
              {!open && <ProfileNavItem forceHideLabel size="default" serverSession={serverSession} user={user} />}
            </div>
          </div>
          <div
            style={{ height: `calc(100dvh - ${MOBILE_NAV_HEIGHT}px)` }}
            className={clsx(
              "mobile-nav-slide-in fixed left-0 top-[72px] z-30 h-screen w-screen bg-bg-1",
              open ? "active" : ""
            )}>
            <div className="flex h-full flex-col overflow-y-scroll pb-16">
              <VerticalNav serverSession={serverSession} user={user} size="lg" onClickMenuItem={toggleOpen} />
            </div>
          </div>
        </div>
      </div>
      <SecondarySidebar serverSession={serverSession} />
    </div>
  )
}
